import { css } from "@emotion/react";
import { theme } from "@minted/minted-components";

export const smMarginBottomStyles = css`
  margin-bottom: ${theme.spacing.x3};
`;

export const medMarginBottomStyles = css`
  margin-bottom: ${theme.spacing.x6};
`;

export const lgMarginBottomStyles = css`
  margin-bottom: ${theme.spacing.x8};
`;
